export const AMEX_INSTITUTION_ID = 'cd471c3b-eca7-487c-9a41-ed802b938fca';

export function isAmexOffer(creditCardOffer: { institution: { id: string } }) {
  return creditCardOffer.institution.id === AMEX_INSTITUTION_ID;
}
